import { inject, Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { parse, Renderer } from 'marked';

@Injectable()
export class MarkdownService {
  private sanitizer = inject(DomSanitizer);

  private renderer = new Renderer();
  private options = {
    gfm: true,
    renderer: this.renderer,
    tables: true,
  };

  render(markdown = ''): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, parse(markdown, this.options));
  }

  plaintext(markdown = ''): string {
    const div = document.createElement('div');
    div.innerHTML = this.render(markdown);
    return div.innerText;
  }
}
